import type { ButtonHTMLAttributes, ReactNode } from 'react';

export const Button = ({ label }: { label: ReactNode } & ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <button>{label}</button>;
};
